import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../../components/common';
import DatePickerMui from '../../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../../components/ui';
import { convToTime } from '../../../../../../utils/helpers';
import { useQuery } from '../../../../../../hooks/UseQuery';

interface IProps {
  // year: number;
  // month: string;
  top20?: any;
}
const THead = ({}: IProps) => {
  const annual_month = useQuery('annual_date') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={35}
        rowSpan={3}
        labels={['Doc. No.- ', 'Rev. No.- ', 'Date:- ']}
        values={['F05 QAD 05', '00', '18.06.18']}
        heading="Monthly Data Date Wise"
      />
      <tr style={{ background: '#9775fa', color: 'white' }}>
        <th
          colSpan={35}
          align="left"
          style={{ background: 'orange', color: 'black', fontWeight: 'bold' }}
        >
          Month : {annual_month}
        </th>
      </tr>
      <tr>
        {[
          'Sr No.',
          'Customer',
          'PART NAME',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
          '22',
          '23',
          '24',
          '25',
          '26',
          '27',
          '28',
          '29',
          '30',
          '31',
          'Partwise Monthly  Rej.',
          // 'Rate / Piece',
          // 'Total Cost Debit',
          // 'Total',
        ].map((headingData, index) => (
          <th>{headingData}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
